import React from 'react'
import injectSheet from 'react-jss'
import styles from './comments-skeleton.styles'
import { Table, HeadCell } from 'pobble-components/dist/table'
import Bone from 'pobble-components/dist/bone'
import EntrySkeleton from './entry-skeleton/entry-skeleton'

const CommentsSkeleton = ({ classes }) => (
  <Table>
    <thead>
      <tr>
        <HeadCell className={classes.allCell}>
          <Bone className={classes.all} />
        </HeadCell>
        <HeadCell className={classes.dateCell}>
          <Bone className={classes.date} />
        </HeadCell>
        <HeadCell className={classes.commentCell}>
          <Bone className={classes.comment} />
        </HeadCell>
        <HeadCell className={classes.statusCell}>
          <Bone className={classes.status} />
        </HeadCell>
        <HeadCell className={classes.contextMenuCell} />
      </tr>
    </thead>
    <tbody>
      <EntrySkeleton commentWidth={90} />
      <EntrySkeleton commentWidth={70} />
      <EntrySkeleton commentWidth={80} />
      <EntrySkeleton commentWidth={50} />
      <EntrySkeleton commentWidth={90} />
    </tbody>
  </Table>
)

export default injectSheet(styles)(CommentsSkeleton)
